import { lazy, Suspense, useEffect } from 'react';
import { LaunchDarklyOsmo } from '@gonfalon/branding/osmo';

import { trackSignUp } from '#utils/loginUtils';

import { SignUpHero } from './SignUpHero';
import { SignUpMain } from './SignUpMain';

import styles from './SignUpRouteEntry.module.css';

const SignUpTrialAside = lazy(async () =>
  import(/* webpackChunkName: "SignUpTrialAside" */ './SignUpTrialAside').then((module) => ({
    default: module.SignUpTrialAside,
  })),
);

export type SignUpRouteEntryVariant = 'default' | 'trial';

export type SignUpRouteEntryProps = {
  variant?: SignUpRouteEntryVariant;
};

export const SignUpRouteEntry = ({ variant = 'default' }: SignUpRouteEntryProps) => {
  const isTrialAside = variant === 'trial';

  useEffect(() => {
    // Event name predates the trial aside (1Mind era); kept for analytics continuity.
    trackSignUp(isTrialAside ? '1Mind Sign Up Page Loaded' : 'Sign Up Page Loaded');
  }, [isTrialAside]);

  const rootClassName = isTrialAside ? `${styles.root} ${styles.rootTrialAside}` : styles.root;
  const mainClassName = isTrialAside ? `${styles.main} ${styles.mainTrialAside}` : styles.main;

  return (
    <div className={rootClassName}>
      <main data-theme="default" className={mainClassName}>
        <div className={styles.mainContentContainer}>
          <div className={styles.mainContent}>
            <span className={styles.osmo}>
              <LaunchDarklyOsmo />
            </span>
            <SignUpMain headingClassName={styles.newTextSize} />
          </div>
        </div>
      </main>
      {isTrialAside ? (
        <Suspense fallback={null}>
          <SignUpTrialAside />
        </Suspense>
      ) : (
        <aside className={styles.aside} data-theme="dark">
          <SignUpHero />
        </aside>
      )}
    </div>
  );
};
